import UserContainer from './user.container';
import TeamsContainer from './teams.container';
import TeamContainer from './team.container';

export const userContainer = new UserContainer();
export const teamsContainer = new TeamsContainer();
export const teamContainer = new TeamContainer();
